// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-sponsor-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 20px 16px;
  background-color: #fff;
  border-radius: 8px;
  max-width: 400px;
  margin: 0 auto;
}

.home-page-sponsor-top-text {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #002129;
  margin-bottom: 15px !important;
}
@media (min-width: 900px) {
  .home-page-sponsor-top-text {
    font-size: 14px !important;
  }
}

.home-page-sponsor-logo {
  width: 200px;
  height: auto;
  margin-bottom: 15px;
  object-fit: contain;
}
@media (min-width: 900px) {
  .home-page-sponsor-logo {
    width: 400px;
  }
}

.home-page-sponsor-link {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #00AAD1;
  text-decoration: underline;
}
@media (min-width: 900px) {
  .home-page-sponsor-link {
    font-size: 14px !important;
  }
}

.home-page-tagline-container {
  text-align: center;
  margin: 0 auto;
  width: 100%;
}

.home-page-tagline-text {
  color: #002129;
  text-align: center;
  font-size: 29px !important;
  font-weight: 800 !important;
  padding: 16px;
}
@media (max-width: 900px) {
  .home-page-tagline-text {
    font-size: 16px !important;
    font-weight: 700 !important;
  }
}

.home-page-tagline-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 32px;
}
@media (max-width: 900px) {
  .home-page-tagline-body {
    max-width: 450px;
    margin: 0 auto;
  }
}

.home-page-tagline-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  text-align: center;
  max-width: 650px;
}
@media (max-width: 900px) {
  .home-page-tagline-section {
    text-align: left;
  }
}

.home-page-tagline-section-text {
  font-size: 14px !important;
}
@media (max-width: 900px) {
  .home-page-tagline-section-text {
    font-size: 12px !important;
  }
}

.home-page-tagline-section-header {
  font-weight: 700;
}

.home-page-prizes-container {
  text-align: center;
}

.home-page-prizes-header {
  color: #002129;
  text-align: center;
  font-size: 20px !important;
  font-weight: 800 !important;
  text-decoration: underline;
  margin: 0;
  margin-top: 16px !important;
}
@media (max-width: 900px) {
  .home-page-prizes-header {
    font-size: 16px !important;
    font-weight: 700 !important;
    margin: 0 auto;
  }
}

.home-page-prizes-text {
  color: #002129;
  text-align: center;
  font-size: 18px !important;
  font-weight: 500 !important;
  margin-bottom: 20px !important;
}
@media (max-width: 900px) {
  .home-page-prizes-text {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }
}

.prize-text {
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-page-prizes-text .highlight {
  font-weight: 700 !important;
}

.home-page-prizes-text .red {
  color: #CC293C;
  font-weight: 700 !important;
}

.home-page-how-to {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 355px;
  padding: 0px 32px;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .home-page-how-to {
    max-width: 450px;
  }
}

.home-page-how-to-header {
  color: #002129;
  text-align: center;
  font-size: 20px !important;
  font-weight: 800 !important;
  text-decoration: none;
  margin-top: 32px !important;
  margin-bottom: 16px !important;
}
@media (max-width: 900px) {
  .home-page-how-to-header {
    font-size: 16px !important;
    font-weight: 700 !important;
    margin: 0 auto !important;
    margin-top: 32px !important;
    margin-bottom: 16px !important;
    text-decoration: underline;
  }
}

.home-page-how-to-text {
  color: #002129;
  text-align: left;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-bottom: 20px !important;
}
@media (max-width: 900px) {
  .home-page-how-to-text {
    font-size: 12px !important;
    margin-bottom: 10px !important;
  }
}

.home-page-how-to-text-block {
  display: block;
  margin: 16px 0;
}

.home-page-how-to-text-block:first-of-type {
  margin-top: 0;
}

.home-page-how-to-rules-link {
  color: #00AAD1;
  text-decoration: underline;
  cursor: pointer;
}

.game-home-page-screen-capture-main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  max-width: 1000px;
  margin-bottom: 32px;
}

.game-home-page-screen-capture-row {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 60px;
  width: 100%;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-row {
    flex-direction: column;
    gap: 10px;
  }
}

.game-home-page-screen-capture-pair-container {
  display: flex;
  flex-direction: row;
  gap: 60px;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-pair-container {
    flex-direction: column;
    gap: 10px;
  }
}

.game-home-page-screen-capture-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-container {
    gap: 8px;
    margin-bottom: 24px;
  }
}

.game-home-page-screen-capture-title {
  color: #002129;
  text-align: center;
  font-size: 16px;
  font-weight: 800;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-title {
    font-weight: 700;
  }
}

.game-home-page-screen-capture-image-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 122px;
  height: 235px;
  background: #FFF;
  cursor: pointer;
}

.game-home-page-screen-capture-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: fill;
}`, "",{"version":3,"sources":["webpack://./src/components/GameHomePage/GameHomePageComponents/GameHomePageComponents.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAGE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;AAAJ;AAEI;EANF;IAOI,0BAAA;EACJ;AACF;;AAEE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EANF;IAOI,YAAA;EAEJ;AACF;;AACE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,0BAAA;AAEJ;AAAI;EANF;IAOI,0BAAA;EAGJ;AACF;;AAWA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;AARF;;AAYA;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,aAAA;AATF;AAWE;EAPF;IAQI,0BAAA;IACA,2BAAA;EARF;AACF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AATF;AAWE;EAPF;IAQI,gBAAA;IACA,cAAA;EARF;AACF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAWE;EATF;IAUI,gBAAA;EARF;AACF;;AAYA;EACE,0BAAA;AATF;AAWE;EAHF;IAII,0BAAA;EARF;AACF;;AAYA;EACE,gBAAA;AATF;;AA0BA;EACE,kBAAA;AAvBF;;AA2BA;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,SAAA;EACA,2BAAA;AAxBF;AA0BE;EATF;IAUI,0BAAA;IACA,2BAAA;IACA,cAAA;EAvBF;AACF;;AA2BA;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAxBF;AA0BE;EAPF;IAQI,0BAAA;IACA,8BAAA;EAvBF;AACF;;AA2BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAxBF;;AA4BA;EACE,2BAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,2BAAA;AAzBF;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjCF;AAmCE;EAVF;IAWI,gBAAA;EAhCF;AACF;;AAmCA;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,2BAAA;EACA,8BAAA;AAhCF;AAkCE;EATF;IAUI,0BAAA;IACA,2BAAA;IACA,yBAAA;IACA,2BAAA;IACA,8BAAA;IACA,0BAAA;EA/BF;AACF;;AAkCA;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AA/BF;AAiCE;EAPF;IAQI,0BAAA;IACA,8BAAA;EA9BF;AACF;;AAiCA;EACE,cAAA;EACA,cAAA;AA9BF;;AAkCA;EACE,aAAA;AA/BF;;AAkCA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AA/BF;AAiCE;EAPF;IAQM,sBAAA;IACA,SAAA;EA9BJ;AACF;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9BF;AAgCE;EALF;IAMM,sBAAA;IACA,SAAA;EA7BJ;AACF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA7BF;AA+BE;EANF;IAOM,QAAA;IACA,mBAAA;EA5BJ;AACF;;AA+BA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA5BF;AA8BE;EANF;IAOM,gBAAA;EA3BJ;AACF;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AA3BF","sourcesContent":["// SPONSORS SECTION\n.home-page-sponsor-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0px 20px 16px;\n    background-color: #fff; // Adjust background as needed\n    border-radius: 8px;\n    max-width: 400px;\n    margin: 0 auto; // Center on page\n  }\n  \n  .home-page-sponsor-top-text {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    margin-bottom: 15px !important;\n  \n    @media (min-width: 900px) {\n      font-size: 14px !important;\n    }\n  }\n  \n  .home-page-sponsor-logo {\n    width: 200px;\n    height: auto;\n    margin-bottom: 15px;\n    object-fit: contain; // Ensure logo is contained\n  \n    @media (min-width: 900px) {\n      width: 400px;\n    }\n  }\n  \n  .home-page-sponsor-link {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    color: #00AAD1;\n    text-decoration: underline;\n  \n    @media (min-width: 900px) {\n      font-size: 14px !important;\n    }\n  }\n\n\n\n\n\n\n\n\n\n  // GAME TAGLINE AND BODY SECTION\n\n  // Container styling for the entire component\n.home-page-tagline-container {\n  text-align: center; // Center align content\n  margin: 0 auto; // Center container horizontally\n  width: 100%;\n}\n\n// Styling for the tag line text\n.home-page-tagline-text {\n  color: #002129;\n  text-align: center;\n  font-size: 29px !important; // Default size\n  font-weight: 800 !important; // Default weight\n  padding: 16px;\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    font-size: 16px !important; // Reduced size for mobile\n    font-weight: 700 !important;\n  }\n}\n\n// Container styling for the body content\n.home-page-tagline-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 32px;\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    max-width: 450px;\n    margin: 0 auto;\n  }\n}\n\n// Styling for each section within the body\n.home-page-tagline-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n  text-align: center;\n  max-width: 650px;\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    text-align: left;\n  }\n}\n\n// Styling for the section text\n.home-page-tagline-section-text {\n  font-size: 14px !important; // Default size\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    font-size: 12px !important; // Reduced size for mobile\n  }\n}\n\n// Header styling within each section\n.home-page-tagline-section-header {\n  font-weight: 700;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n  // POOL PRIZES SECTION\n\n  // Styling for the container Box\n.home-page-prizes-container {\n  text-align: center; // Center align content\n}\n\n// Styling for the header\n.home-page-prizes-header {\n  color: #002129;\n  text-align: center;\n  font-size: 20px !important; // Default size\n  font-weight: 800 !important; // Default weight\n  text-decoration: underline;\n  margin: 0;\n  margin-top: 16px !important;\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    font-size: 16px !important; // Reduced size for mobile\n    font-weight: 700 !important;\n    margin: 0 auto;\n  }\n}\n\n// Styling for the prize text\n.home-page-prizes-text {\n  color: #002129;\n  text-align: center;\n  font-size: 18px !important; // Default size\n  font-weight: 500 !important; // Default weight\n  margin-bottom: 20px !important; // Default margin\n\n  @media (max-width: 900px) { // Adjust to your mobile breakpoint\n    font-size: 16px !important;\n    margin-bottom: 10px !important; // Reduced margin for mobile\n  }\n}\n\n// Ensure text within .home-page-prizes-text is on the same line\n.prize-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n// Highlight style\n.home-page-prizes-text .highlight {\n  font-weight: 700 !important;\n}\n\n.home-page-prizes-text .red {\n  color: #CC293C;\n  font-weight: 700 !important;\n}\n\n\n\n\n\n\n\n// HOW TO PLAY SECTION\n\n.home-page-how-to {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%; // Full width to center content\n  max-width: 355px; // Adjust max width as needed\n  padding: 0px 32px;\n  margin: 0 auto; // Center container horizontally\n\n  @media (max-width: 900px) {\n    max-width: 450px;\n  }\n}\n\n.home-page-how-to-header {\n  color: #002129;\n  text-align: center;\n  font-size: 20px !important; // Default size\n  font-weight: 800 !important; // Default weight\n  text-decoration: none; // Default text decoration\n  margin-top: 32px !important; // Default margin top\n  margin-bottom: 16px !important; // Default margin bottom\n\n  @media (max-width: 900px) {\n    font-size: 16px !important; // Reduced size for mobile\n    font-weight: 700 !important;\n    margin: 0 auto !important; // Center on mobile\n    margin-top: 32px !important; // Default margin top\n    margin-bottom: 16px !important; // Default margin bottom\n    text-decoration: underline;\n  }\n}\n\n.home-page-how-to-text {\n  color: #002129;\n  text-align: left;\n  font-size: 14px !important; // Default size\n  font-weight: 500 !important; // Default weight\n  margin-bottom: 20px !important; // Default margin\n\n  @media (max-width: 900px) {\n    font-size: 12px !important; // Reduced size for mobile\n    margin-bottom: 10px !important; // Reduced margin for mobile\n  }\n}\n\n.home-page-how-to-text-block {\n  display: block;\n  margin: 16px 0; // Margin between blocks\n}\n\n// Remove top margin for the first item\n.home-page-how-to-text-block:first-of-type {\n  margin-top: 0; // Remove top margin for the first item\n}\n\n.home-page-how-to-rules-link {\n  color: #00AAD1;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.game-home-page-screen-capture-main-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 32px;\n  max-width: 1000px;\n  margin-bottom: 32px;\n}\n\n.game-home-page-screen-capture-row {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 60px;\n  width: 100%;\n\n  @media (max-width: 900px) {\n      flex-direction: column;\n      gap: 10px;\n  }\n}\n\n.game-home-page-screen-capture-pair-container {\n  display: flex;\n  flex-direction: row;\n  gap: 60px;\n\n  @media (max-width: 900px) {\n      flex-direction: column;\n      gap: 10px;\n  }\n}\n\n.game-home-page-screen-capture-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n\n  @media (max-width: 900px) {\n      gap: 8px;\n      margin-bottom: 24px;\n  }\n}\n\n.game-home-page-screen-capture-title {\n  color: #002129;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 800;\n\n  @media (max-width: 900px) {\n      font-weight: 700;\n  }\n}\n\n.game-home-page-screen-capture-image-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 122px;\n  height: 235px;\n  background: #FFF;\n  cursor: pointer;\n}\n\n.game-home-page-screen-capture-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: fill;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
